export default __webpack_public_path__ + "static/media/font-learntodo.82cd6c1e.png";